import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=0f68a7ae&"
import script from "./EmployeeForm.ts?vue&type=script&lang=js&"
export * from "./EmployeeForm.ts?vue&type=script&lang=js&"
import style0 from "./EmployeeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports